import React from 'react';
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function SalesChart({ deals = [] }) {
  const closedWon = deals.filter(d => d.stage === 'CLOSED_WON' && d.closeDate);

  const byMonth = {};
  closedWon.forEach(d => {
    const date = new Date(d.closeDate);
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    byMonth[key] = (byMonth[key] || 0) + (d.value || 0);
  });

  const data = Object.keys(byMonth).sort().slice(-12).map(key => ({
    month: MONTH_NAMES[parseInt(key.split('-')[1], 10) - 1],
    sales: byMonth[key],
  }));

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Closed Won by Month</h2>
      {data.length === 0 ? (
        <p className="text-gray-500 text-center py-12">No closed deals yet.</p>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip formatter={(v) => `$${v.toLocaleString()}`} />
            <Line type="monotone" dataKey="sales" stroke="#dc2626" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
